module.exports = __webpack_public_path__ + "img/chien.141f1937.png";